import type { CatalogTree } from '../types';

export const notifications = {
  unreadOnly: 'Yalnızca okunmamışlar',
} as const satisfies CatalogTree;
